import React, { Suspense } from 'react';
import { StyledEngineProvider } from '@mui/material/styles';
import { FirestoreProvider, useFirebaseApp } from 'reactfire';
import { getFirestore } from 'firebase/firestore';
import './App.css';
import AppRoutes from './Routes';
import Theme from './Components/Theme/Theme';
import OrdersState from './Context/Orders/OrdersState';
import Loader from './Components/Loader/Loader';
import AuthState from './Context/Auth/AuthState';

function App() {
	return (
		<Suspense fallback={<Loader />}>
			<FirestoreProvider sdk={getFirestore(useFirebaseApp())}>
				<AuthState>
					<OrdersState>
						<StyledEngineProvider injectFirst>
							<Theme>
								<AppRoutes />
							</Theme>
						</StyledEngineProvider>
					</OrdersState>
				</AuthState>
			</FirestoreProvider>
		</Suspense>
	);
}

export default App;
